import React from 'react';

const BLUEBERRY_URL = process.env.NODE_ENV === 'production'
  ? '/blueberry'  // 프로덕션: nginx 프록시
  : 'http://localhost:3002'; // 로컬 개발

function BlueberryFarm() {
  return (
    <div>
      <h1 className="text-2xl font-light text-gray-800 mb-6">머드네농장 정산</h1>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" style={{ height: 'calc(100vh - 160px)' }}>
        <iframe
          src={BLUEBERRY_URL}
          title="머드네농장 정산"
          className="w-full h-full border-none"
          allow="clipboard-write"
        />
      </div>
    </div>
  );
}

export default BlueberryFarm;
